export default "https://yastatic.net/s3/frontend/vconf-frontend/_/NoCallsStub.8dfe5b09.svg";